// extracted by mini-css-extract-plugin
export default {"overlay":"PasswordModal_overlay__Qyn5B","modal":"PasswordModal_modal__jcxrc"};